<div class="title-and-content-align-{{showStatusIcon?'center':'left'}}">
  <h2 mat-dialog-title>
    @if (showStatusIcon) {
      <div class="app-status-image" [ngClass]="status"></div>
    }
    {{ title }}
  </h2>
  <div [innerHTML]="content" mat-dialog-content></div>
  <div mat-dialog-actions>
    <button [matDialogClose]="true" class="swm-full-button" color="primary" mat-dialog-close mat-flat-button tabindex="-1">
      {{ label }}
    </button>
  </div>
</div>
